// @ts-nocheck
import { name2num, num2name, } from "../RawDataType";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../../../runtime/json/scalar";
import { WireType, } from "../../../../../../runtime/wire/index";
import { default as serialize, } from "../../../../../../runtime/wire/serialize";
import { default as Long, } from "../../../../../../runtime/Long";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        type: "RAW_DATA_TYPE_UNSPECIFIED",
        uploadUrl: "",
        downloadUrl: "",
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.type !== undefined)
        result.type = tsValueToJsonValueFns.enum(value.type);
    if (value.uploadUrl !== undefined)
        result.uploadUrl = tsValueToJsonValueFns.string(value.uploadUrl);
    if (value.downloadUrl !== undefined)
        result.downloadUrl = tsValueToJsonValueFns.string(value.downloadUrl);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.type !== undefined)
        result.type = jsonValueToTsValueFns.enum(value.type);
    if (value.uploadUrl !== undefined)
        result.uploadUrl = jsonValueToTsValueFns.string(value.uploadUrl);
    if (value.downloadUrl !== undefined)
        result.downloadUrl = jsonValueToTsValueFns.string(value.downloadUrl);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.type !== undefined) {
        const tsValue = value.type;
        result.push([1, { type: WireType.Varint, value: new Long(name2num[tsValue]) }]);
    }
    if (value.uploadUrl !== undefined) {
        const tsValue = value.uploadUrl;
        result.push([2, tsValueToWireValueFns.string(tsValue)]);
    }
    if (value.downloadUrl !== undefined) {
        const tsValue = value.downloadUrl;
        result.push([3, tsValueToWireValueFns.string(tsValue)]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.Varint ? num2name[wireValue.value[0]] : undefined;
        if (value === undefined)
            break field;
        result.type = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.uploadUrl = value;
    }
    field: {
        const wireValue = wireFields.get(3);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.downloadUrl = value;
    }
    return result;
}
